'use strict';

const isPlainObject = require('../rlink-type-utils/isPlainObject');

module.exports = function shape (shapeCheckers, ...args) {
  let checker = (obj, key, cname, location, fullName) => {
    let value = obj[key];
    if (typeof value !== 'object' || value === null) {
      return new TypeError(`Value at ${fullName} is not an non-null object`);
    }
    for (let [shapeKey, memberChecker] of Object.entries(shapeCheckers)) {
      let check = memberChecker(value, shapeKey, cname, location, `${fullName}.${shapeKey}`);
      if (check) {
        return check;
      }
    }
  };
  checker.makeNew = () => ({});
  checker.getCheckerForKey = key => shapeCheckers[key];
  checker.checkerName = 'shape';
  if (args.length > 0) {
    throw new Error(`Extraneous arguments to ${checker.checkerName}`);
  }
  if (!isPlainObject(shapeCheckers)) {
    throw new Error(`Invalid argument type to ${checker.checkerName}: ${shapeCheckers}`);
  }
  for (let [key, keyChecker] of Object.entries(shapeCheckers)) {
    if (typeof keyChecker !== 'function') {
      throw new Error(`Invalid checker at ${key} for ${checker.checkerName}: ${keyChecker}`);
    }
    if (!keyChecker.checkerName) {
      throw new Error(`Non-rlink-shape checker at ${key} for ${checker.checkerName}. Are you trying to mix shapes and PropTypes? (this is not supported)`);
    }
  }
  return checker;
};



// WEBPACK FOOTER //
// ./lib/rlink-shapes/shape.js